/**
 * @fileoverview Divider line between the layout header and the rest of the page in the Listings Launch flow.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/divider.module.scss';

/**
 * Divider line between the layout header and the rest of the page
 * @return {React.ReactNode}
*/
export const Divider = () => {
  return (
    <hr className={styles.divider}/>
  );
};
